import styled, { css } from 'styled-components';

import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';

export const VideoContainer = styled.div`
  padding: 0;
`;

export const SelfHostedWrapper = styled.div`
  position: relative;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const IframeWrapper = styled.div`
  overflow: hidden;
  position: relative;
  display: grid;
  aspect-ratio: 16/9;

  ${mediaTablet(css`
    &:first-child {
      margin-top: 0;
    }
  `)}

  ${mediaDesktop(css`
    &:first-child {
      min-height: 400px;
    }
  `)}
`;

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  object-fit: fill;
  transform: translate(-50%, -50%);

  ${mediaDesktop(css`
    &:first-child {
      min-height: 400px;
    }
  `)}
`;

export const Indicators = styled.div`
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  ${mediaTablet(css`
    width: 64px;
    height: 64px;
  `)}
`;

export const IndicatorsWrapper = styled(Indicators)`
  left: 0;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  padding: 0 12px 12px;

  ${mediaTablet(css`
    height: 84px;
    padding: 0 20px 20px;
  `)}
`;

export const IconIndicatorWrapper = styled(Indicators)<{ isVimeo?: boolean }>`
  right: 0;
  margin: ${({ isVimeo }) => (isVimeo ? '0 30px 10px 0' : '0 10px 10px 0')};
`;

export const AzurePlaceholder = styled.div<{ imageSrc: string }>`
  width: 100%;
  height: 100%;
  background: url(${({ imageSrc }) => imageSrc}) no-repeat center center / cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  cursor: pointer;

  &::before {
    content: '';
    width: 50px;
    height: 66px;
    position: absolute;
    inset: 0;
    margin: auto;
    background: url('/svgs/play.svg') no-repeat center center / cover;
  }
`;
